import { irReasonsSlice } from "./irReasonsSlice";
import * as defaultActions from "../../../../../redux/_common";
import * as fields from "../../pages/IRData/tabs/irReasons/edit/constants";

const { actions } = irReasonsSlice;
const moduleUrl = '/api/imagerecognition/scenereasons';



export const setValidationErrors = actions.setValidationErrors;

export const getItems = (params: {}) => defaultActions.getItems(moduleUrl, actions, params);
export const getItemForEdit = (id: string) => defaultActions.getItem(`${moduleUrl}/${id}`, actions);

export const deleteItem = (id: string) => defaultActions.deleteItem(`${moduleUrl}/${id}`, actions);
export const saveItem = (item: {}, id: string | null) =>
  defaultActions.saveItem(
      moduleUrl,
      actions,
      item,
      id,
  );

// Select
export const getDropDownItems = (params: {}) => defaultActions.getDropDownItems(`${moduleUrl}/select`, actions, params);

//Reset state
export const clearItem = () => defaultActions.clearItem(actions);
export const clear = () => defaultActions.clearAll(actions);
export const clearError = () => defaultActions.clearErrors(actions);
